import {Component, Input} from '@angular/core';
import {SafeResourceUrl} from '@angular/platform-browser';
import {FitMedProfile} from '@models/data/fit-med-profile/FitMedProfile';
import { FileStorageService } from '@services/core/file-storage/file-storage.service';
import {hasValue} from '@shared/utils/helpers';

@Component({
    selector: 'app-profile-picture',
    templateUrl: './profile-picture.component.html',
    styleUrls: ['./profile-picture.component.scss'],
    standalone: true
})
export class ProfilePictureComponent {
  profilePic: SafeResourceUrl = null;

  @Input() set fitMedProfileId(content: string) {
    if (hasValue(content)) {
      this.profilePic = this.fileStorageService.getProfilePicture(content);
    }
  }

  @Input() set src(content: SafeResourceUrl) {
    if (hasValue(content)) {
      this.profilePic = content;
    }
  }

  @Input() class: string = null;

  constructor(public fileStorageService: FileStorageService) {
  }

  changeSrcToDefault(error): void {
    this.profilePic = '/assets/images/placeholders/profile-pic-placeholder.png';
  }
}
